import { Reveal } from "./Reveal";
import { PILLARS } from "../../data";

export const Capabilities = () => {
  return (
    <section id="capabilities" data-testid="capabilities" className="relative py-28 lg:py-40 border-t border-hairline bg-surface/20">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
          <Reveal className="lg:col-span-8">
            <span className="font-mono text-xs tracking-[0.3em] uppercase text-gold">What We Do</span>
            <h2 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter text-parchment mt-6 text-balance">
              Full-spectrum <span className="italic text-gold">capital advisory.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-4 lg:justify-self-end">
            <p className="text-stone leading-relaxed max-w-sm">
              Decades of experience across investment banking, capital raising, investor relations, family office advisory and strategic growth.
            </p>
          </Reveal>
        </div>

        <div className="border-t border-hairline">
          {PILLARS.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.05}>
              <div data-testid={`pillar-${p.n}`} className="group grid lg:grid-cols-12 gap-6 py-10 border-b border-hairline hover:bg-ink transition-colors duration-500 px-2">
                <div className="lg:col-span-1">
                  <span className="font-mono text-xs tracking-[0.25em] text-gold">{p.n}</span>
                </div>
                <div className="lg:col-span-4">
                  <h3 className="font-serif text-3xl lg:text-4xl font-light text-parchment tracking-tight group-hover:text-gold transition-colors duration-300">{p.title}</h3>
                  <p className="text-stone text-sm leading-relaxed mt-3 max-w-sm">{p.body}</p>
                </div>
                <div className="lg:col-span-7">
                  <div className="flex flex-wrap gap-x-8 gap-y-3">
                    {p.items.map((it) => (
                      <span key={it} className="flex items-center gap-2 text-sm text-parchment/75">
                        <span className="h-1 w-1 rotate-45 bg-gold/70" />
                        {it}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
